import styled from 'styled-components/macro';
import { COLORS, BOX_SHADOW } from 'styleguide';

const PhotoBlockWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid ${COLORS.background};
  cursor: grab;

  &:last-child {
    border: none;
  }

  &.sortable-photo_active {
    border-color: transparent;
    background-color: ${COLORS.line};
    box-shadow: ${BOX_SHADOW.dropdown};
  }
`;

export default PhotoBlockWrapper;
